import React, { FC } from "react";
import { cn } from "../../../util/classNameConstructor";
import Transition from "../../atoms/animations/Transition";
import Button from "../../core/button/Button";
import Icon from "../../core/icon/Icon";

interface InfoToastProps extends React.HTMLAttributes<HTMLDivElement> {
  text: string;
  closeable?: boolean;
  position?: React.CSSProperties["position"];
  withShadow?: boolean;
  transition?: boolean;
  button?: React.ReactNode;
}
const InfoToast = ({
  className,
  text,
  closeable,
  position,
  withShadow,
  button,
  transition,
}: InfoToastProps) => {
  const [showLocal, setShow] = React.useState(true);
  return (
    <Transition
      show={showLocal}
      from={{ x: 0, y: -50, scale: 1 }}
      leave={{ x: 0, y: -50, scale: 1 }}
      enter={{ x: 0, y: 0, scale: 1 }}
      style={{
        position: position || "relative",
        zIndex: 999,
        pointerEvents: "none",
      }}
      transitionActive={transition}
    >
      <div
        className={cn(
          "bg-surface-highlight-subdued body-md body-md pointer-events-auto relative flex rounded-lg p-3",
          withShadow && "shadow-xl",
          className,
        )}
        // style={{ maxWidth: "calc(100% - 20px)" }}
      >
        {closeable && (
          <div className="z-7 absolute right-1 top-1">
            <Button
              variant="shapeless"
              size="small"
              leadingIcon="x-sm"
              onClick={() => setShow(false)}
            />
          </div>
        )}
        <div
          className={cn("z-0 flex flex-col gap-3")}
          style={{ maxWidth: "calc(100% - 25px)" }}
        >
          <div className="flex gap-3">
            <Icon name="info-circle-fill" className="shrink-0" />
            <span>{text}</span>
          </div>
          {button && button}
        </div>
      </div>
    </Transition>
  );
};

export default InfoToast;
